import { error } from '../constants/actions'

const initialState = {
  summaryPageError: {
    title: null,
    description: null,
  },
  paymentPageError: {
    title: null,
    description: null,
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case error.SUMMARY_PAGE_ERROR:
      return { ...state, summaryPageError: action.payload }
    case error.PAYMENT_PAGE_ERROR:
      return { ...state, paymentPageError: action.payload }
    default:
      return state
  }
}
